import {observer} from 'mobx-react';
import React from 'react';
import {PromiseMessage} from '../../../../lib/components';
import {X5LessonStore} from '../X5LessonStore';

@observer
export class ActivateSnapshotControls extends React.Component<{ store: X5LessonStore }> {
  render() {
    const store = this.props.store;
    if (store.activateSnapshot === null)
      return null;

    const activate = store.activateSnapshot;
    const isFailure = activate.save?.isRejected === true;

    return (<>
      <PromiseMessage label="Saving" state={activate.save} align="right"/>
      {
        isFailure &&
        <div className="row justify-content-end">
          <div className="col-auto">
            <button type="button" className="btn btn-primary"
                    onClick={store.completeActivateSnapshot}> Retry
            </button>
            <button type="button" className="btn btn-primary"
                    onClick={store.cancel}> Cancel
            </button>
          </div>
        </div>
      }
    </>);
  }
}
